import type { IMatchRow, MatchStatus } from "../../../apis/saved-list"
import type { InputRow } from "./parse"

export type DisplayStatus = MatchStatus | "INVALID"

export type DisplayRow = {
  key: string
  code: string
  quantity: number
  status: DisplayStatus
  variantId?: string
  parentVariantId?: string
  name?: string
  skuCode?: string
  image?: string
  price?: number
  available?: number
  /** What goes into the cart: the quantity, the stock on LOW_STOCK, 0 when nothing can. */
  addQty: number
}

const addQtyOf = (m: IMatchRow) => {
  if (!m.variantId) return 0
  if (m.status === "MATCHED") return m.quantity
  if (m.status === "LOW_STOCK") return Math.max(0, Number(m.addQuantity ?? m.available) || 0)
  return 0
}

/** Server-matched rows in response order, then the lines whose quantity could not be read. */
export function buildDisplayRows(input: InputRow[], matched: IMatchRow[]): DisplayRow[] {
  const fromServer: DisplayRow[] = matched.map((m, i) => ({
    key: `m-${i}-${m.code}`,
    code: m.code,
    quantity: m.quantity,
    status: m.status,
    variantId: m.variantId,
    parentVariantId: m.parentVariantId,
    name: m.name,
    skuCode: m.skuCode || m.code,
    image: m.image,
    price: m.price,
    available: m.available,
    addQty: addQtyOf(m),
  }))
  const invalid: DisplayRow[] = input
    .filter((r) => r.invalid)
    .map((r) => ({ key: `i-${r.line}`, code: r.code, quantity: r.quantity, status: "INVALID", skuCode: r.code, addQty: 0 }))
  return [...fromServer, ...invalid]
}

export const isBad = (r: DisplayRow) => r.status === "NOT_FOUND" || r.status === "INVALID"
export const isAddable = (r: DisplayRow) => r.addQty > 0 && !!r.variantId
export const lineAmount = (r: DisplayRow) => (Number(r.price) || 0) * r.addQty
